// import React, { useState, useRef, useEffect } from 'react';
// import ReactMarkdown from 'react-markdown';
// import { fetchAiChat,fetchAiInsights } from '../services_1/api';
// // import { set } from '../../../zoho-dashboard-backend/src/app';

// const AiChatWidget = ({ projectId , projectData }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [input, setInput] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const messagesEndRef = useRef(null);

//   // Initialize with a welcome message
//   const [messages, setMessages] = useState([
//     { role: 'assistant', content: 'Hi! I am your AI Project Assistant. How can I help you analyze this sprint? You can ask me questions or click below for a quick summary.' }
//   ]);

//   // Auto-scroll to the bottom of the chat
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   const sendMessage = async (customText = null) => {
//     const textToSend = customText || input;
//     if (!textToSend.trim() || !projectId) return;

//     const newMessages = [...messages, { role: 'user', content: textToSend }];
//     setMessages(newMessages);
//     setInput('');
//     setIsLoading(true);

//   //   setMessages(prev => [...prev, { role: 'assistant', content: '' }]);

//   //   try {
//   //     // Filter out the hardcoded welcome message before sending to API to save tokens
//   //     const apiMessages = newMessages.filter(m => m.content !== messages[0].content);
//   //     const aiResponse = await fetchAiChat(projectId, apiMessages, projectData);
      
//   //     setMessages(prev => [...prev, aiResponse]);
//   //   } catch (error) {
//   //     setMessages(prev => [...prev, { role: 'assistant', content: '**Error:** Unable to connect to the AI service.' }]);
//   //   } finally {
//   //     setIsLoading(false);
//   //   }
//   // };

//     setMessages(prev => [...prev, { role: 'assistant', content: '' }]);

//       try {
//         // Filter out the hardcoded welcome message
//         const apiMessages = newMessages.filter(m => m.content !== messages[0].content);
        
//         // 3. Call the stream API
//         await fetchAiChat(projectId, apiMessages, projectData, (newTextChunk) => {
//           setMessages(prev => {
//             const updatedMessages = [...prev];
//             const lastIndex = updatedMessages.length - 1;

//             // SAFEGUARD 1: Check if array is valid
//             if (lastIndex < 0) return prev;
            
//             const currentMessage = updatedMessages[lastIndex];

//             // SAFEGUARD 2: Safely append the chunk
//             updatedMessages[lastIndex] = {
//               ...currentMessage,
//               content: (currentMessage?.content || "") + newTextChunk
//             };

//             return updatedMessages;
//           });
//         });
//       } catch (error) {
//         console.error("Chat stream error:", error);
//         // Overwrite the empty placeholder with the error message
//         setMessages(prev => {
//           const updated = [...prev];
//           updated[updated.length - 1] = { role: 'assistant', content: '**Error:** Unable to connect to the AI service.' };
//           return updated;
//         });
//       } finally {
//         setIsLoading(false);
//       }
//   };

//   // const handleSummarizeClick = () => {
//   //   sendMessage("Please provide a 3-point executive briefing on the current project risks, velocity, and top performers.");
//   // };


//   // 🚨 REPLACE the existing handleSummarizeClick with this:
//   const handleSummarizeClick = async () => {
//     if (!projectId || isLoading) return;

//     // 1. Show a clean, short request in the chat window from the user
//     const userRequest = { role: 'user', content: 'Generate an Executive Summary for this project.' };
//     setMessages(prev => [...prev, userRequest]);
//     setIsLoading(true);

//     setMessages(prev => [...prev, { role: 'assistant', content: '--..--..--' }]);

//     try {
//       // 2. Call the dedicated summary endpoint (The long prompt lives safely on the backend)
//       await fetchAiInsights(projectId, projectData,(newTextChunk) => {
//         setMessages(prev => {

//           const updatedMessages = [...prev];
//           const lastIndex = updatedMessages.length - 1;

//           if (lastIndex < 0) return prev;

//           const currentMessage = updatedMessages[lastIndex];

//           updatedMessages[lastIndex] = {
//             ...currentMessage,
//             // ...updatedMessages[lastIndex],
//             content: updatedMessages[lastIndex].content + newTextChunk
//           };
//           return updatedMessages;
//       });    
    
//     });
      
//       // 3. Append the formatted response to the chat
//       // setMessages(prev => [...prev, aiResponse]);
//     } catch (error) {
//       console.error("Summary error:", error);
//       setMessages(prev => [...prev, { role: 'assistant', content: '**Error:** Unable to generate the summary.' }]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleClose = () => {
//     setIsOpen(false);
//     setIsExpanded(false);
//   };

//   if (!projectId) return null; // Hide widget if no project is selected

//   return (
//     <div style={{
//       position: 'fixed',
//       zIndex: 1000,
//       // NEW: Dynamically change the wrapper position based on expansion
//       ...(isOpen && isExpanded ? {
//         top: 0, left: 0, right: 0, bottom: 0,
//         backgroundColor: 'rgba(0,0,0,0.5)',
//         backdropFilter: 'blur(4px)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '24px'
//       } : {
//         bottom: '30px', right: '30px'
//       })
//     }}>
      
//       {/* Floating Action Button */}
//       {!isOpen && (
//         <button 
//           onClick={() => setIsOpen(true)}
//           style={{
//             width: '60px', height: '60px', borderRadius: '50%', backgroundColor: '#4f46e5',
//             color: 'white', border: 'none', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//             fontSize: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center'
//           }}
//         >
//           ✨
//         </button>
//       )}

//       {/* Chat Window */}
//       {isOpen && (
//         <div style={{
//           width: '380px', height: '550px', backgroundColor: 'white', borderRadius: '16px',
//           boxShadow: '0 8px 24px rgba(0,0,0,0.2)', display: 'flex', flexDirection: 'column',
//           border: '1px solid #e2e8f0', overflow: 'hidden'
//         }}>
//           {/* Header */}
//           <div style={{ backgroundColor: '#4f46e5', color: 'white', padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <h3 style={{ margin: 0, fontSize: '1rem' }}>✨ AI Assistant</h3>
//             <button onClick={() => setIsOpen(false)} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', fontSize: '1.2rem' }}>✖</button>
//           </div>

//           {/* Messages Area */}
//           <div style={{ flex: 1, padding: '16px', overflowY: 'auto', backgroundColor: '#f8fafc' }}>
//             {messages.map((msg, idx) => (
//               <div key={idx} style={{
//                 marginBottom: '12px', display: 'flex',
//                 justifyContent: msg.role === 'user' ? 'flex-end' : 'flex-start'
//               }}>
//                 <div style={{
//                   maxWidth: '80%', padding: '10px 14px', borderRadius: '12px', fontSize: '0.9rem', lineHeight: '1.5',
//                   backgroundColor: msg.role === 'user' ? '#4f46e5' : '#ffffff',
//                   color: msg.role === 'user' ? 'white' : '#1e293b',
//                   border: msg.role === 'assistant' ? '1px solid #e2e8f0' : 'none',
//                   boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
//                 }}>
//                   {msg.role === 'user' ? msg.content : (
//                     <div className="ai-markdown-content">
//                       <ReactMarkdown>{msg.content}</ReactMarkdown>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))}
            
//             {/* Quick Action Button */}
//             {messages.length === 1 && (
//               <button 
//                 onClick={handleSummarizeClick}
//                 style={{ marginTop: '10px', padding: '8px 12px', background: '#e0e7ff', color: '#4f46e5', border: '1px solid #c7d2fe', borderRadius: '20px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '500' }}
//               >
//                 📊 Generate Executive Summary
//               </button>
//             )}

//             {isLoading && <div style={{ fontSize: '0.85rem', color: '#64748b', marginTop: '8px' }}>AI is thinking...</div>}
//             <div ref={messagesEndRef} />
//           </div>

//           {/* Input Area */}
//           <div style={{ padding: '12px', borderTop: '1px solid #e2e8f0', display: 'flex', gap: '8px', backgroundColor: 'white' }}>
//             <input 
//               type="text" 
//               value={input} 
//               onChange={(e) => setInput(e.target.value)}
//               onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
//               placeholder="Ask about this project..."
//               style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none' }}
//               disabled={isLoading}
//             />
//             <button 
//               onClick={() => sendMessage()} 
//               disabled={isLoading || !input.trim()}
//               style={{ backgroundColor: '#4f46e5', color: 'white', border: 'none', borderRadius: '8px', padding: '0 16px', cursor: 'pointer', fontWeight: 'bold' }}
//             >
//               Send
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AiChatWidget;


import React, { useState, useRef, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { fetchAiChat, fetchAiInsights } from '../services_1/api';

const AiChatWidget = ({ projectId, projectData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false); // NEW: State to track fullscreen expansion
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  // Initialize with a welcome message
  const [messages, setMessages] = useState([
    { role: 'assistant', content: 'Hi! I am your AI Project Assistant. How can I help you analyze this sprint? You can ask me questions or click below for a quick summary.' }
  ]);

  // Auto-scroll to the bottom of the chat
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = async (customText = null) => {
    const textToSend = customText || input;
    if (!textToSend.trim() || !projectId) return;

    const newMessages = [...messages, { role: 'user', content: textToSend }];
    setMessages(newMessages);
    setInput('');
    setIsLoading(true);

    setMessages(prev => [...prev, { role: 'assistant', content: '' }]);

    try {
      // Filter out the hardcoded welcome message
      const apiMessages = newMessages.filter(m => m.content !== messages[0].content);
      
      // Call the stream API
      await fetchAiChat(projectId, apiMessages, projectData, (newTextChunk) => {
        setMessages(prev => {
          const updatedMessages = [...prev];
          const lastIndex = updatedMessages.length - 1;

          // SAFEGUARD 1: Check if array is valid
          if (lastIndex < 0) return prev;
          
          const currentMessage = updatedMessages[lastIndex];

          // SAFEGUARD 2: Safely append the chunk
          updatedMessages[lastIndex] = {
            ...currentMessage,
            content: (currentMessage?.content || "") + newTextChunk
          };

          return updatedMessages;
        });
      });
    } catch (error) {
      console.error("Chat stream error:", error);
      // Overwrite the empty placeholder with the error message
      setMessages(prev => {
        const updated = [...prev];
        updated[updated.length - 1] = { role: 'assistant', content: '**Error:** Unable to connect to the AI service.' };
        return updated;
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSummarizeClick = async () => {
    if (!projectId || isLoading) return;

    // 1. Show a clean, short request in the chat window from the user
    const userRequest = { role: 'user', content: 'Generate an Executive Summary for this project.' };
    setMessages(prev => [...prev, userRequest]);
    setIsLoading(true);

    setMessages(prev => [...prev, { role: 'assistant', content: '--..--..--' }]);

    try {
      // 2. Call the dedicated summary endpoint
      await fetchAiInsights(projectId, projectData, (newTextChunk) => {
        setMessages(prev => {
          const updatedMessages = [...prev];
          const lastIndex = updatedMessages.length - 1;
          if (lastIndex < 0) return prev;

          const currentMessage = updatedMessages[lastIndex];
          updatedMessages[lastIndex] = {
            ...currentMessage,
            content: updatedMessages[lastIndex].content + newTextChunk
          };
          return updatedMessages;
        });    
      });
    } catch (error) {
      console.error("Summary error:", error);
      setMessages(prev => [...prev, { role: 'assistant', content: '**Error:** Unable to generate the summary.' }]);
    } finally {
      setIsLoading(false);
    }
  };

  // Close widget and reset expansion state
  const handleClose = () => {
    setIsOpen(false);
    setIsExpanded(false);
  };

  if (!projectId) return null; // Hide widget if no project is selected

  return (
    <div style={{
      position: 'fixed',
      zIndex: 1000,
      // NEW: Dynamically change the wrapper position based on expansion
      ...(isOpen && isExpanded ? {
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(5, 12, 20, 0.6)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px'
      } : {
        bottom: '30px', right: '30px'
      })
    }}>
      
      {/* Floating Action Button */}
      {!isOpen && (
        <button 
          onClick={() => setIsOpen(true)}
          style={{
            width: '60px', height: '60px', borderRadius: '50%', background: 'linear-gradient(135deg, #56c7dd, #74aee8)',
            color: '#07121d', border: '1px solid rgba(159, 223, 255, 0.22)', cursor: 'pointer', boxShadow: '0 8px 22px rgba(0,0,0,0.28)',
            fontSize: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'transform 0.2s ease',
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          ✨
        </button>
      )}

      {/* Chat Window */}
      {isOpen && (
        <div style={{
          background: 'linear-gradient(180deg, rgba(12, 24, 36, 0.98), rgba(16, 31, 45, 0.96))',
          boxShadow: '0 12px 40px rgba(0,0,0,0.3)', 
          display: 'flex', flexDirection: 'column',
          border: '1px solid rgba(159, 223, 255, 0.16)', overflow: 'hidden',
          transition: 'all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)', // Smooth transition
          // NEW: Dynamically change size based on expansion
          ...(isExpanded ? {
            width: '100%', height: '100%', maxWidth: '1100px', borderRadius: '20px'
          } : {
            width: '380px', height: '550px', borderRadius: '16px'
          })
        }}>
          {/* Header */}
          <div style={{ background: 'linear-gradient(135deg, rgba(86, 199, 221, 0.18), rgba(116, 174, 232, 0.12))', color: '#eff5fb', padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(159, 223, 255, 0.12)' }}>
            <h3 style={{ margin: 0, fontSize: '1rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
              ✨ AI Assistant
            </h3>
            
            {/* Header Action Buttons */}
            <div style={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
              {/* NEW: Expand/Collapse Button */}
              <button 
                onClick={() => setIsExpanded(!isExpanded)} 
                title={isExpanded ? "Collapse window" : "Expand window"}
                style={{ background: 'none', border: 'none', color: '#eff5fb', cursor: 'pointer', display: 'flex', padding: '4px', opacity: 0.9 }}
              >
                {isExpanded ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="4 14 10 14 10 20"></polyline>
                    <polyline points="20 10 14 10 14 4"></polyline>
                    <line x1="14" y1="10" x2="21" y2="3"></line>
                    <line x1="3" y1="21" x2="10" y2="14"></line>
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <polyline points="9 21 3 21 3 15"></polyline>
                    <line x1="21" y1="3" x2="14" y2="10"></line>
                    <line x1="3" y1="21" x2="10" y2="14"></line>
                  </svg>
                )}
              </button>
              
              {/* Close Button */}
              <button onClick={handleClose} title="Close" style={{ background: 'none', border: 'none', color: '#eff5fb', cursor: 'pointer', fontSize: '1.2rem', padding: '0 4px' }}>✖</button>
            </div>
          </div>

          {/* Messages Area */}
          <div style={{ flex: 1, padding: '20px', overflowY: 'auto', background: 'linear-gradient(180deg, rgba(8, 18, 29, 0.96), rgba(12, 24, 37, 0.9))' }}>
            {messages.map((msg, idx) => (
              <div key={idx} style={{
                marginBottom: '16px', display: 'flex',
                justifyContent: msg.role === 'user' ? 'flex-end' : 'flex-start'
              }}>
                <div style={{
                  maxWidth: isExpanded ? '65%' : '85%', // Allow wider text blocks when expanded
                  padding: '12px 16px', borderRadius: '12px', fontSize: '0.95rem', lineHeight: '1.6',
                  background: msg.role === 'user'
                    ? 'linear-gradient(135deg, #56c7dd, #74aee8)'
                    : 'linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.04))',
                  color: msg.role === 'user' ? '#07121d' : '#eff5fb',
                  border: msg.role === 'assistant' ? '1px solid rgba(159, 223, 255, 0.12)' : 'none',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
                }}>
                  {msg.role === 'user' ? msg.content : (
                    <div className="ai-markdown-content ai-markdown-content--chat">
                      <ReactMarkdown>{msg.content}</ReactMarkdown>
                    </div>
                  )}
                </div>
              </div>
            ))}
            
            {/* Quick Action Button */}
            {messages.length === 1 && (
              <button 
                onClick={handleSummarizeClick}
                style={{ marginTop: '10px', padding: '10px 16px', background: 'rgba(241, 201, 138, 0.12)', color: '#f1c98a', border: '1px solid rgba(241, 201, 138, 0.22)', borderRadius: '20px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: '600', transition: 'background 0.2s ease' }}
                onMouseOver={(e) => e.currentTarget.style.background = 'rgba(241, 201, 138, 0.2)'}
                onMouseOut={(e) => e.currentTarget.style.background = 'rgba(241, 201, 138, 0.12)'}
              >
                📊 Generate Executive Summary
              </button>
            )}

            {isLoading && <div style={{ fontSize: '0.85rem', color: '#9db4c7', marginTop: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
               <span style={{ animation: 'pulse 1.5s infinite' }}>●</span>
               AI is thinking...
            </div>}
            <div ref={messagesEndRef} />
          </div>

          {/* Input Area */}
          <div style={{ padding: '16px', borderTop: '1px solid rgba(159, 223, 255, 0.12)', display: 'flex', gap: '12px', background: 'rgba(10, 20, 31, 0.96)' }}>
            <input 
              type="text" 
              value={input} 
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
              placeholder="Ask about this project..."
              style={{ flex: 1, padding: '12px 16px', borderRadius: '10px', border: '1px solid rgba(159, 223, 255, 0.14)', outline: 'none', fontSize: '0.95rem', background: 'rgba(255,255,255,0.06)', color: '#eff5fb' }}
              disabled={isLoading}
            />
            <button 
              onClick={() => sendMessage()} 
              disabled={isLoading || !input.trim()}
              style={{ background: 'linear-gradient(135deg, #56c7dd, #74aee8)', color: '#07121d', border: 'none', borderRadius: '10px', padding: '0 24px', cursor: isLoading || !input.trim() ? 'not-allowed' : 'pointer', fontWeight: 'bold', opacity: isLoading || !input.trim() ? 0.6 : 1, transition: 'opacity 0.2s ease' }}
            >
              Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AiChatWidget;
